import { render, staticRenderFns } from "./StatusAlert.vue?vue&type=template&id=2a8bcb8e&scoped=true&"
import script from "./StatusAlert.vue?vue&type=script&lang=js&"
export * from "./StatusAlert.vue?vue&type=script&lang=js&"
import style0 from "./StatusAlert.vue?vue&type=style&index=0&id=2a8bcb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bcb8e",
  null
  
)

export default component.exports